// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--wEJuP","button":"button--kbCfW","buttonWrapper":"buttonWrapper--glHqQ","toggledButton":"toggledButton--CUzIm button--kbCfW","content":"content--PcVVI"};